import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import ClassicRewardsSealIcon from 'LuxKit/Icons/loyalty/ClassicRewardsSealIcon'
import { useIntl } from 'react-intl'

function MaldivesCharterRewardSeatsAvailableLabel() {
  const intl = useIntl()
  const label = intl.formatMessage({
    id: 'fCPKJ957f06YEieNFOd-',
    defaultMessage: 'Reward seats available',
  })

  return (
    <Group direction="horizontal" verticalAlign="center" gap={4}>
      <ClassicRewardsSealIcon size="XS" colour="highlight-primary-dark" aria-hidden />
      <BodyText variant="small" weight="bold" colour="highlight-primary-dark">
        {label}
      </BodyText>
    </Group>
  )
}

export default MaldivesCharterRewardSeatsAvailableLabel
